import { cn } from "@/lib/utils";
import type { SVGProps } from "react";

/**
 * Wise Wheels–style circular badge (PakWheels favicon geometry, recolored teal/cyan).
 * Official vector was not retrievable (site 403); swap `frontend/public/brands/wise-wheels.svg` later if you add one.
 */
export function WiseWheelsIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 50 50"
      className={cn("shrink-0", className)}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <g>
        <path
          fill="#FFFFFF"
          stroke="#0F766E"
          strokeMiterlimit={10}
          d="M25.003,0.632c-13.458,0-24.371,10.91-24.371,24.362
		c0,13.458,10.913,24.375,24.371,24.375c13.462,0,24.365-10.916,24.365-24.375C49.368,11.542,38.465,0.632,25.003,0.632z"
        />
        <path
          fill="#22D3EE"
          d="M25.003,0.089c-13.758,0-24.914,11.153-24.914,24.905c0,13.758,11.156,24.917,24.914,24.917
		c13.762,0,24.908-11.159,24.908-24.917C49.911,11.242,38.765,0.089,25.003,0.089z M25.003,44.494c-10.77,0-19.5-8.728-19.5-19.5
		c0-10.763,8.731-19.491,19.5-19.491c10.767,0,19.498,8.728,19.498,19.491C44.501,35.767,35.77,44.494,25.003,44.494z"
        />
        <circle cx="25" cy="25" r="11.2" fill="#ECFEFF" />
        <path
          fill="#0C4A6E"
          d="M14.2 35.2 L18.4 14.8 L25 26.8 L31.6 14.8 L35.8 35.2 H31.1 L27.8 19.4 L25 23.9 L22.2 19.4 L18.9 35.2 Z"
        />
        <circle cx="25" cy="25" r="3.15" fill="#22D3EE" />
      </g>
    </svg>
  );
}
